export const ListQueryKey = 'projectWelfareProjectOrders';
export const DetailQueryKey = 'projectWelfareProjectOrder';

export const Urls = {
  selectUrl: '/welfareProjectOrder/list',
  updateUrl: '/welfareProjectOrder/update',
  deleteUrl: '/welfareProjectOrder/delete',
  createUrl: '/welfareProjectOrder/create',
  detailUrl: '/welfareProjectOrder/info',
};
